export default __webpack_public_path__ + "static/media/like_desktop_app.02765022.gif";